"use client"

import { useTranslations } from "next-intl"

import { Textarea } from "@/components/ui/textarea"
import { useMidCallNotesStore } from "@/stores/mid-call-notes-store"

export function MidCallNotesPanel() {
  const t = useTranslations("telephony")
  const { notes, isOpen, setNotes } = useMidCallNotesStore()

  if (!isOpen) return null

  return (
    <div className="w-full mb-2">
      <Textarea
        value={notes}
        onChange={(e) => setNotes(e.target.value)}
        placeholder={t("midCallNotes.placeholder")}
        rows={3}
      />
    </div>
  )
}
